import { useState } from 'react';
import { Reveal } from '../components/Reveal.tsx';
import { Accented } from '../components/Accented.tsx';
import type { SiteContent } from '../lib/api.ts';

/** Keyed ethos.* in admin: the section was called that before it was renamed. */
const FALLBACK = {
  'ethos.eyebrow': 'The studio',
  'ethos.title': 'Small studio, *full attention.*',
  'ethos.lede':
    'A private, home-based facial studio in Finchampstead, near Wokingham. Warm, quiet and one-to-one, so you can escape the day and leave refreshed, confident and renewed.',
  'ethos.body': '',
};

/**
 * The one cream band on the page. The tone-cream class turns the colour roles
 * over for everything inside it, so nothing here needs a colour of its own.
 */
export function Studio({ content }: { content: SiteContent }) {
  const text = (key: keyof typeof FALLBACK) => (content[key] ?? FALLBACK[key]).trim();

  const [photo, setPhoto] = useState(true);

  return (
    <section className="studio tone-cream" id="studio">
      <div className="page studio__inner">
        <Reveal className="studio__photo-wrap">
          <figure className="studio__photo placeholder">
            {photo ? (
              <img
                src="/images/studio.png"
                alt="The treatment room at The Renewal Studio"
                width={548}
                height={732}
                loading="lazy"
                onError={() => setPhoto(false)}
              />
            ) : (
              <div className="studio__photo-placeholder">
                <svg viewBox="0 0 48 48" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
                  <rect x="5" y="5" width="38" height="38" rx="3" />
                  <circle cx="32" cy="16" r="4" />
                  <path d="m5 34 12-13 14 17M26 32l7-8 10 11" />
                </svg>
                <span>Studio photo</span>
              </div>
            )}
          </figure>
        </Reveal>
        <Reveal delay={100} className="studio__copy">
          <p className="eyebrow">{text('ethos.eyebrow')}</p>
          <h2 className="studio__title">
            <Accented text={text('ethos.title')} />
          </h2>
          <p className="studio__lede">{text('ethos.lede')}</p>
          {text('ethos.body') && <p className="studio__body">{text('ethos.body')}</p>}
        </Reveal>
      </div>
    </section>
  );
}
